import { getIssueKey } from '@atlassian/jira-router-resources-utils/src/utils/get-issue-key/index.tsx';
import { createResource } from '@atlassian/react-resource-router';
import { withResourceEarlyData } from '../../utils.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const issueMediaUserAuthResource = createResource<any>(
	withResourceEarlyData({
		type: 'ISSUE_MEDIA_USER_AUTH',
		getKey: ({ match }) => {
			const issueKey = getIssueKey(match);
			return issueKey || '';
		},
		getData: () => null,
		isBrowserOnly: true,
	}),
);
